import type { TChatDocument } from '../types';

export const parseChatDocument = (data?: string | null): TChatDocument | null => {
    if (!data) return null;
    try {
        const parsed = JSON.parse(data);
        if (parsed?.type !== 'document' || !parsed.documentId || !parsed.pathwayId) return null;
        return {
            documentId: String(parsed.documentId),
            pathwayId: String(parsed.pathwayId),
            fileName: String(parsed.fileName ?? '').trim(),
            fileType: String(parsed.fileType ?? ''),
        };
    } catch {
        return null;
    }
};
